import "./document-search.scss";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Spinner from "../../../shared/components/spinner/spinner";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData } from "../../../shared/utils/api";
import ControlledTable, {IColumn} from "../../components/controlled-table/controlled-table";
import { ISortedBy } from "../../components/data-table/data-table";
import Page from "../../components/page/page";

const documentsColumns: IColumn[] = [
  {
    key: "file_name",
    displayName: "File name",
    dataType: {
      type: "text",
    },
    sortable: true,
  },
  {
    key: "file_type",
    displayName: "Type",
    dataType: {
      type: "text",
    },
    sortable: true,
  },
  {
    key: "date",
    displayName: "Uploaded date",
    dataType: {
      type: "dateTime",
    },
    sortable: true,
  },
  {
    key: "alertcase_title",
    displayName: "Alertcase title",
    dataType: {
      type: "text",
    },
    sortable: false,
  },
  {
    key: "alertcase_number",
    displayName: "Alertcase number",
    dataType: {
      type: "text",
    },
    sortable: false,
  },
  {
    key: "alertcase_title",
  displayName: "Alertcase title",
  dataType: {
    type: "text"
  },
  sortable: false
},
{
  key: "content",
    displayName: "Content",
    dataType: {
      type: "text",
    },
    sortable: true,
  },

];

const DocumentSearch = () => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [sortedByCol, setSortedByCol] = useState<ISortedBy>({column: "date", direction: "desc"});
  const [searchTerm, setSearchTerm] = useState("");
  const [allDocuments, setAllDocuments] = useState<any[]>([]); // eslint-disable-line
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const { sendRequest: getAllDocuments, status: getAllDocumentsStatus, data: getAllDocumentsResult } = useHttp(getAllData, false, authCtx.token, "document", "manager");

  useEffect(() => {
    setOffset(0);
    setAllDocuments([]);
    setHasMore(true);
    setIsLoading(true);
    getAllDocuments(`all_documents?filter_value=${searchTerm}&order_by=${sortedByCol.column} ${sortedByCol.direction}&limit=50&offset=0`);
  }, [sortedByCol, searchTerm]);

  useEffect(() => {
    if (getAllDocumentsResult && getAllDocumentsStatus === "completed") {
      setIsLoading(false);
      setIsLoadingMore(false);

      if (offset === 0) {
        setAllDocuments(getAllDocumentsResult);
      } else {
        setAllDocuments((prev) => [...prev, ...getAllDocumentsResult]);
      }

      if (getAllDocumentsResult.length < 50) {
        setHasMore(false);
      }
    }
  }, [getAllDocumentsResult, getAllDocumentsStatus, offset]);

  const handleScroll = () => {
    if (!isLoadingMore && hasMore && getAllDocumentsResult && getAllDocumentsResult.length >= 50) {
      const newOffset = offset + 50;
      setOffset(newOffset);
      setIsLoadingMore(true);
      getAllDocuments(`all_documents?filter_value=${searchTerm}&is_search=true&order_by=${sortedByCol.column}%20${sortedByCol.direction}&limit=50&offset=${newOffset}`);
    }
  };

  const handleExternalSearchValue = (value: string) => {
    setSearchTerm(value);
  };

  const handleRowClick = (id: string) => {
    const document = getAllDocumentsResult.find((document: any) => document.id === id); // eslint-disable-line
    navigate(`/manager/alertcases/${document.alertcase_id}`);
  };

  return (
    <div className="documentSearch">
      <Page
        title={{
          text: "Document search",
          placeholder: "Document search"
        }}>
        <div className="documentSearch-container">
          {(isLoading || isLoadingMore) && <Spinner />}
        </div>

        <ControlledTable
          data={allDocuments}
          columns={documentsColumns}
          onSorted={setSortedByCol}
          onRowClick={handleRowClick}
          onScroll={handleScroll}
          selectionMode="off"
          allowCollapsedText={true}
          textTruncateLimit={100}
          externalSearch={true}
          externalSearchValue={handleExternalSearchValue}
          highlightOnSearch={true}
        />
      </Page>
    </div>
  );
};

export default DocumentSearch;